export const SERVICE_DETAIL_BANNERS = {
  appDevelopment: "url('/assets/images/banners/services/app-development/app-development.jpg')",
  blockchain: "url('/assets/images/banners/services/blockchain/blockchain.jpg')",
  businessIntelligence: "url('/assets/images/banners/services/business-intelligence/business-intelligence.jpg')",
  callCenter: "url('/assets/images/banners/services/call-center/call-center.jpg')",
  dataScience: "url('/assets/images/banners/services/data-science/data-science.jpg')",
  digitalMarketing: "url('/assets/images/banners/services/digital-marketing/digital-marketing.jpg')",
  digitalMediaCenter: "url('/assets/images/banners/services/digital-media-center/digital-media-center.jpg')",
  fintech: "url('/assets/images/banners/services/fintech/fintech.jpg')",
  publicity: "url('/assets/images/banners/services/publicity/publicity-banner.jpg')",
  socialMedia: "url('/assets/images/banners/services/social-media/social-media.jpg')",
  webDevelopment: "url('/assets/images/banners/services/web-development/web-development.jpg')",
} as const;
